
define('text!common/views/content/share-count.html',[],function () { return '<h3 class="sharecount__heading"><%=icon%> Shares</h3>\n<div class="sharecount__value sharecount__value--full">0</div>\n<div class="sharecount__value sharecount__value--short">0</div>\n';});

